import * as React from "react";
import { useTranslation } from "react-i18next";
const PageDescription = () => {
  const { t } = useTranslation("enterprise_security_sigma");
  return /* @__PURE__ */ React.createElement("span", null, t("page_description.text"));
};
export default PageDescription;
